import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ValueList from '../../../../../components/ValueList';
import Literal from '../../../../../components/Literal';
import stylejs from './styles';

const propTypes = {
    data: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
};

class SearchUsers extends Component {
    state = {};

    onChangeValue = (item) => {
        const { onChange, origin } = this.props;
        onChange && onChange(item, origin);
    };

    processDataRender = (data) => {
        let { searchText } = this.props;
        return data.map((valueList) => {
            let text = valueList.Name;
            let id = valueList.Id;
            return {
                text,
                id,
                value: <span style={stylejs.valueListTextMenu}>{text}</span>,
            };
        });
    };
    renderValueList = () => {
        let { data, error, searchText } = this.props;
        return (
            <ValueList
                data={this.processDataRender(data)}
                onNewRequest={this.onChangeValue}
                errorText={error}
                style={stylejs.inputStyle}
                inputStyle={stylejs.inputStyle}
                hintStyle={stylejs.hintStyle}
                hintText={<Literal literal={'label_selectone'} />}
                searchText={searchText}
            />
        );
    };

    render() {
        let content = this.renderValueList();
        return <div>{content}</div>;
    }
}
SearchUsers.propTypes = propTypes;

export default SearchUsers;
